import React, { useState } from "react";
import { removeItem, getItem } from "../core/storage/storage";

export const AuthContext = React.createContext({
  isAuth: false,
  studentData: {},
  token: "",
  login: () => {},
  logOut: () => {},
  updateData: () => {},
});

const AuthContextProvider = (props) => {
  const jwttokens = getItem("token");
  const [jwtToken, setJwtToken] = useState(jwttokens ? jwttokens : "");
  const studentDatas = JSON.parse(getItem("studentData"));
  const [studentData, setStudentData] = useState(
    studentDatas ? studentDatas : {}
  );
  const [logedIn, setLogedIn] = useState(
    jwttokens && studentDatas ? true : false
  );
console.log(jwtToken)
console.log(logedIn)
  const logedInHandler = (data) => {
    setLogedIn(true);
    setJwtToken(data.jwtToken);
    setStudentData(data.studentModel);
  };
  const LogedOutHandler = () => {
    setJwtToken("");
    setLogedIn(false);
    setStudentData({});
    removeItem("token");
    removeItem("studentData");
  };
  const updateDataHandler = (data) => {
    setStudentData(data);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuth: logedIn,
        studentData: studentData,
        token: jwtToken,
        login: logedInHandler,
        logOut: LogedOutHandler,
        updateData: updateDataHandler,
      }}
    >
      {" "}
      {props.children}{" "}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
